const PremiumIssuance = () =>
  import(/* webpackChunkName 'PremiumIssuance' */ "@/components/PremiumIssuance/PremiumIssuance.vue");

export default {
  path: "premium-issuance",
  name: "premium-issuance",
  meta: {
    label: "Premium issuance",
  },
  props: true,
  component: PremiumIssuance,
};
